// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("./Alert.bs.js");
let React = require("react");
let Loader = require("./Loader.bs.js");
let DialogV5 = require("./DialogV5.bs.js");
let ButtonsV5 = require("./ButtonsV5.bs.js");
let ImageUtils = require("../../../reason/common/imageUtils/ImageUtils.bs.js");
let ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let CropProfilePhoto = require("./CropProfilePhoto.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let AvatarUploadProvider = require("../../../reason/settings/components/AvatarUploadProvider.bs.js");
let SelectProfilePhotoButton = require("./SelectProfilePhotoButton.bs.js");

let acceptedImageTypes = [
  "JPEG",
  "PNG",
  "WEBP"
];

function parseContentType(contentType) {
  switch (contentType) {
    case "image/jpeg" :
      return {
        TAG: "Ok",
        _0: "JPEG"
      };
    case "image/png" :
      return {
        TAG: "Ok",
        _0: "PNG"
      };
    case "image/webp" :
      return {
        TAG: "Ok",
        _0: "WEBP"
      };
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnsupportedMimeType",
          VAL: contentType
        }
      };
  }
}

function ProfilePhotoInput(props) {
  let __buttonText = props.buttonText;
  let __onPhotoSelected = props.onPhotoSelected;
  let onSubmit = props.onSubmit;
  let onPhotoSelected = __onPhotoSelected !== undefined ? __onPhotoSelected : prim => {};
  let buttonText = __buttonText !== undefined ? __buttonText : "Select photo";
  let match = React.useState(() => "Idle");
  let setState = match[1];
  let state = match[0];
  let upload = AvatarUploadProvider.useUpload();
  let onSelectProfilePhoto = file => {
    setState(param => "UploadingInitialPhoto");
    onPhotoSelected();
    let dataUrl = URL.createObjectURL(file);
    ReasonPromise.tap(ReasonPromise.tapError(ReasonPromise.tapOk(upload(dataUrl), param => {
      let key = param.key;
      let id = param.id;
      let fileName = param.fileName;
      let contentType = parseContentType(param.contentType);
      if (contentType.TAG === "Ok") {
        let contentType$1 = contentType._0;
        return ReasonPromise.getOk(Utils__Promise.fromJsPromise(ImageUtils.resize(undefined, 1000, file)), dataURL => setState(param => ({
          TAG: "CroppingPhoto",
          _0: {
            initialPhotoInput: {
              contentType: contentType$1,
              fileName: fileName,
              id: id,
              key: key
            },
            initialPhotoDataUrl: dataURL,
            croppedPhotoDataUrl: dataURL
          }
        })));
      }
      let type_ = contentType._0.VAL;
      setState(param => ({
        TAG: "ErrorUploadingInitialPhoto",
        _0: {
          TAG: "UnsupportedMimeType",
          _0: type_
        }
      }));
    }), param => setState(param => ({
      TAG: "ErrorUploadingInitialPhoto",
      _0: "UploadError"
    }))), param => {
      URL.revokeObjectURL(dataUrl);
    });
  };
  let saveCrop = (cropState, uploadedCrop) => {
    setState(param => ({
      TAG: "SavingCrop",
      _0: cropState
    }));
    let getUpload = Stdlib_Option.getOr(Stdlib_Option.map(uploadedCrop, c => (() => ReasonPromise.resolved({
      TAG: "Ok",
      _0: c
    }))), () => ReasonPromise.tapError(upload(cropState.croppedPhotoDataUrl), param => setState(param => ({
      TAG: "ErrorSavingCrop",
      cropState: cropState,
      error: "UploadError"
    }))));
    return ReasonPromise.tapOk(getUpload(), uploadData => {
      let parsedContentType = Stdlib_Result.getOrThrow(parseContentType(uploadData.contentType), undefined);
      onSubmit({
        croppedPhoto: {
          contentType: parsedContentType,
          fileName: uploadData.fileName,
          id: uploadData.id,
          key: uploadData.key
        },
        originalPhoto: cropState.initialPhotoInput,
        croppedPhotoDataUrl: cropState.croppedPhotoDataUrl
      }, {
        notifyOnSuccess: () => setState(param => "Idle"),
        notifyOnError: error => setState(param => ({
          TAG: "ErrorSavingCrop",
          cropState: cropState,
          error: {
            TAG: "SubmissionError",
            uploadedCrop: uploadData,
            error: error
          }
        }))
      });
    });
  };
  let tmp;
  tmp = typeof state !== "object" ? state !== "Idle" : true;
  let tmp$1;
  let exit = 0;
  let cropState;
  if (typeof state !== "object") {
    tmp$1 = state === "Idle" ? null : JsxRuntime.jsx(Loader.make, {});
  } else {
    switch (state.TAG) {
      case "ErrorUploadingInitialPhoto" :
        let tmp$2 = state._0;
        tmp$1 = typeof tmp$2 !== "object" ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Alert.$$Error.make, {
                title: "There was an error loading your photo. Please try selecting it again"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                    onSelectProfilePhoto: onSelectProfilePhoto,
                    acceptedImageTypes: acceptedImageTypes,
                    children: "Select Photo"
                  }),
                  JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                    onClick: param => setState(param => "Idle"),
                    children: "Cancel"
                  })
                ],
                className: "flex gap-4"
              })
            ],
            className: "flex flex-col gap-4"
          }) : JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Alert.$$Error.make, {
                title: "The photo you selected is not supported. Please try selecting another photo"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                    onSelectProfilePhoto: onSelectProfilePhoto,
                    acceptedImageTypes: acceptedImageTypes,
                    children: "Use Another Photo"
                  }),
                  JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                    onClick: param => setState(param => "Idle"),
                    children: "Cancel"
                  })
                ],
                className: "flex gap-4"
              })
            ],
            className: "flex flex-col gap-4"
          });
        break;
      case "CroppingPhoto" :
      case "SavingCrop" :
        cropState = state._0;
        exit = 1;
        break;
      case "ErrorSavingCrop" :
        cropState = state.cropState;
        exit = 1;
        break;
    }
  }
  if (exit === 1) {
    let tmp$3;
    if (typeof state !== "object" || state.TAG !== "ErrorSavingCrop") {
      tmp$3 = null;
    } else {
      let match$1 = state.error;
      tmp$3 = typeof match$1 !== "object" ? JsxRuntime.jsx(Alert.$$Error.make, {
          title: "There was an error saving your photo. Please try again"
        }) : JsxRuntime.jsx(Alert.$$Error.make, {
          title: match$1.error
        });
    }
    let tmp$4;
    tmp$4 = typeof state !== "object" ? false : state.TAG === "SavingCrop";
    tmp$1 = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(CropProfilePhoto.make, {
          imageURL: cropState.initialPhotoDataUrl,
          onCropURLChange: url => setState(param => ({
            TAG: "CroppingPhoto",
            _0: {
              initialPhotoInput: cropState.initialPhotoInput,
              initialPhotoDataUrl: cropState.initialPhotoDataUrl,
              croppedPhotoDataUrl: url
            }
          }))
        }),
        tmp$3,
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(SelectProfilePhotoButton.make, {
              onSelectProfilePhoto: onSelectProfilePhoto,
              acceptedImageTypes: acceptedImageTypes,
              children: "Use Another Photo"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                  onClick: param => setState(param => "Idle"),
                  children: "Cancel"
                }),
                JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  onClick: param => {
                    let uploadedCrop;
                    if (typeof state !== "object" || state.TAG !== "ErrorSavingCrop") {
                      uploadedCrop = undefined;
                    } else {
                      let match = state.error;
                      uploadedCrop = typeof match !== "object" ? undefined : match.uploadedCrop;
                    }
                    saveCrop(cropState, uploadedCrop);
                  },
                  disabled: tmp$4,
                  children: "Save"
                })
              ],
              className: "flex items-center justify-between gap-4"
            })
          ],
          className: "flex items-center justify-between"
        })
      ],
      className: "flex flex-col gap-4"
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(SelectProfilePhotoButton.make, {
        onSelectProfilePhoto: onSelectProfilePhoto,
        acceptedImageTypes: acceptedImageTypes,
        children: buttonText
      }),
      JsxRuntime.jsx(DialogV5.make, {
        title: "Crop your profile photo",
        isOpen: tmp,
        ariaLabel: "Crop your profile photo",
        onDismiss: () => setState(param => "Idle"),
        size: "XLarge",
        children: tmp$1
      })
    ]
  });
}

let make = ProfilePhotoInput;

exports.make = make;
/* Alert Not a pure module */
